<template>
  <div>
    <el-row>
      <div class="title">{{ compRebuttalTitle }}</div>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-link class="rebuttalTrainingLink" icon="el-icon-video-camera" :underline="false" @click="handleClick">Training Video</el-link>
      </el-col>
      <el-col class="textAlignEnd" :span="12">
        <el-link class="rebuttalTrainingLink" icon="el-icon-download" :underline="false" :href="compTrainingURL" download target="_blank">Training Download</el-link>
      </el-col>
    </el-row>
    <el-dialog title="Rebuttal Training for Coders" :visible.sync="rebuttalTrainingModal" width="50%" :before-close="handleClose" :destroy-on-close="true">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/W_qSotVq1tQ?si=NZ_5tjrEbz_UWYdp" title="Rebuttal Training for Coders" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
export default {
  name: 'rebuttalTraining',
  props: [],
  mixins: [HiaAuthorization],
  data: function() {
    return {
      rebuttalTrainingModal: false,
      rebuttalTitle: 'Rebuttal Training for Coders',
      rebuttalTrainingURL: '/static/documents/Nucleus-Rebuttal-Instructions-for-Client-Coders.pdf'
    }
  },
  components: {},
  methods: {
    handleClick() {
      this.rebuttalTrainingModal = true
    },
    handleClose() {
      this.rebuttalTrainingModal = false
      this.$emit('close')
    }
  },
  computed: {
    compRebuttalTitle() {
      return this.rebuttalManager() ? 'Rebuttal Training for Managers' : 'Rebuttal Training for Coders'
    },
    compTrainingURL() {
      return this.rebuttalManager() ? '/static/documents/Nucleus-Rebuttal-Instructions-for-Rebuttal-Manager.pdf' : '/static/documents/Nucleus-Rebuttal-Instructions-for-Client-Coders.pdf'
    }
  }
}
</script>
<style scoped>
>>> .rebuttalTrainingLink .el-link--inner {
  font-size: 12px;
}

>>> .textAlignEnd {
  text-align: end;
}
>>> .title {
  display: block;
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 0.1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: 400;
  unicode-bidi: isolate;
}
</style>
